// Module
var code = "<span *ngIf=\"totalCartCount > 0\" class=\"float-right badge badge-danger mx-1\">{{totalCartCount}}</span>";
// Exports
module.exports = code;